/** 判断响应体是否像 HTML 错误页（如 nginx 413 页） */
export function isHtmlErrorBody(text?: string | null): boolean {
  const trimmed = String(text || '').trim().toLowerCase();
  if (!trimmed)
    return false;
  return (
    trimmed.startsWith('<!doctype')
    || trimmed.startsWith('<html')
    || trimmed.includes('<title>')
    || trimmed.includes('request entity too large')
  );
}

/**
 * 将 HTTP 状态码映射为用户可读文案；无法识别时返回 undefined。
 * 仅覆盖网关/代理常见的“无业务 JSON”场景，避免覆盖后端自定义 message。
 */
export function getHttpStatusTip(status?: number | null): string | undefined {
  if (status === 413)
    return '文件过大，超出服务器上传限制，请压缩或选择更小的文件后重试';
  if (status === 502 || status === 503 || status === 504)
    return '服务暂时不可用，请稍后重试';
  return undefined;
}

/**
 * 从 HTTP 失败响应中提取适合展示的错误文案，避免把 HTML 错误页直接弹给用户。
 */
export function resolveHttpErrorMessage(options: {
  status?: number | null;
  statusText?: string | null;
  jsonMessage?: string | null;
  bodyText?: string | null;
  fallback?: string;
}): string {
  const statusTip = getHttpStatusTip(options.status);
  if (statusTip)
    return statusTip;

  const jsonMessage = String(options.jsonMessage || '').trim();
  if (jsonMessage)
    return jsonMessage;

  const bodyText = String(options.bodyText || '').trim();
  if (bodyText && !isHtmlErrorBody(bodyText))
    return bodyText.length > 200 ? `${bodyText.slice(0, 200)}...` : bodyText;

  const status = options.status;
  if (status) {
    return options.fallback
      || `请求失败（HTTP ${status}${options.statusText ? `: ${options.statusText}` : ''}）`;
  }

  return options.fallback || '请求失败';
}
